import { render, staticRenderFns } from "./AddressRequired.vue?vue&type=template&id=24e1c597&scoped=true"
import script from "./AddressRequired.vue?vue&type=script&lang=js"
export * from "./AddressRequired.vue?vue&type=script&lang=js"
import style0 from "./AddressRequired.vue?vue&type=style&index=0&id=24e1c597&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1c597",
  null
  
)

export default component.exports